import $ from "jquery";
import Plyr from 'plyr';
import styles from 'plyr/dist/plyr.css';

$('.video_ceb4_plyr').each(function(){
  var $element = $(this);

  const player = new Plyr($element[0], {
    'controls': ['play-large', 'play', 'progress', 'mute', 'volume'],
    'autoplay': true,
    'muted': true,
    'ratio': '16:9'
  });

  // Helper to get a human-readable video title/ID for the event label
  function getVideoLabel() {
    // For YouTube/Vimeo: grab the embed ID from the wrapper div
    var embedId = $element.attr('data-plyr-embed-id');
    // For MP4: grab the src from the <source> tag
    var src = $element.find('source').attr('src');
    return embedId || src || 'unknown';
  }

  // Track: Play
  player.on('play', function() {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'video_play', {
        'event_category': 'Video',
        'video_title': getVideoLabel(),
        'video_provider': $element.attr('data-plyr-provider') || 'html5'
      });
    }
  });

  // Track: Pause
  player.on('pause', function() {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'video_pause', {
        'event_category': 'Video',
        'video_title': getVideoLabel(),
        'video_provider': $element.attr('data-plyr-provider') || 'html5',
        'video_percent': Math.round(player.currentTime / player.duration * 100)
      });
    }
  });

  // Track: Ended
  player.on('ended', function() {
    if (typeof gtag !== 'undefined') {
      gtag('event', 'video_complete', {
        'event_category': 'Video',
        'video_title': getVideoLabel(),
        'video_provider': $element.attr('data-plyr-provider') || 'html5'
      });
    }
  });

  // Track: Progress milestones (25%, 50%, 75%)
  var milestones = [25, 50, 75];
  var reached = {};

  player.on('timeupdate', function() {
    if (!player.duration) return;
    var percent = Math.round(player.currentTime / player.duration * 100);

    milestones.forEach(function(milestone) {
      if (percent >= milestone && !reached[milestone]) {
        reached[milestone] = true;
        if (typeof gtag !== 'undefined') {
          gtag('event', 'video_progress', {
            'event_category': 'Video',
            'video_title': getVideoLabel(),
            'video_percent': milestone,
            'video_provider': $element.attr('data-plyr-provider') || 'html5'
          });
        }
      }
    });
  });

});